import { TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from "../api/config";

const safeStorage = {
    get(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {
            /* ignore */
        }
    },
    remove(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (e) {
            /* ignore */
        }
    },
};

export const tokenStorage = {
    getAccess() {
        return safeStorage.get(TOKEN_STORAGE_KEY);
    },
    setAccess(token) {
        if (token) {
            safeStorage.set(TOKEN_STORAGE_KEY, token);
        } else {
            safeStorage.remove(TOKEN_STORAGE_KEY);
        }
    },
    getRefresh() {
        return safeStorage.get(REFRESH_TOKEN_STORAGE_KEY);
    },
    setRefresh(token) {
        if (token) {
            safeStorage.set(REFRESH_TOKEN_STORAGE_KEY, token);
        } else {
            safeStorage.remove(REFRESH_TOKEN_STORAGE_KEY);
        }
    },
    clear() {
        safeStorage.remove(TOKEN_STORAGE_KEY);
        safeStorage.remove(REFRESH_TOKEN_STORAGE_KEY);
    },
};
